<template>
  <v-container fluid class="px-8 py-0">
    <template v-slot:after-heading> </template>
    <v-row class="d-flex justify-space-between mx-1 mb-0">
      <div>
        <v-row>
        
          <v-text-field
            v-model="listQuery.garden_name"
            label="小区名称"
            hide-details
            single-line
            class="mx-3 mb-3"
            style="max-width: 100px;"
          />
         
        </v-row>
      </div>
      <div>
        <v-row class="mt-2">
          <v-btn @click="getQuery" color="primary" class="mx-1">
            查询
            <v-icon right>mdi-magnify</v-icon>
          </v-btn>

          <v-btn @click="resetQuery" color="primary" class="mx-1">
            重置
            <v-icon right>mdi-lock-reset</v-icon>
          </v-btn>
        
          <!-- <export-excel
            v-if="isAdminRole"
            :fields="exportMBFields"
            worksheet="户主数据"
            name="魏塘街道公寓房安置户主数据.xls"
            type="xlsx"
            :fetch="getListforExport"
            class="mx-1"
          >
            <v-btn v-if="isAdminRole" color="primary">
              导出
              <v-icon right>mdi-arrow-down-bold-circle-outline</v-icon>
            </v-btn>
          </export-excel> -->
           

          <div v-if="isAdminRole">
            <AddBuildDialog />
          </div>
        </v-row>
      </div>
    </v-row>

    <v-alert
      :value="alert"
      color="red"
      dark
      border="top"
      icon="mdi-bell"
      transition="scale-transition"
    >
      {{ alert_text }}
    </v-alert>
    <v-simple-table fixed-header class="pa-3">
      <template v-slot:default>
        <thead>
          <tr>
            <th>ID</th>
            <th>小区名称</th>
            <th>总套数</th>
            <th>大 | 中 | 小</th>
            <th>施工单位</th>
            <th>建设单位</th>
            <th>监理单位</th>
            <th>设计单位</th>
            <th>项目总投资(万元)</th>
            
            <th>施工时间</th>
            <th>竣工时间</th>
            <th>交房时间</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in items" :key="row.id" :disabled="row.is_freeze==1">
            <td>{{ row.id }}</td>
            <td>
              <!-- <v-icon style="with:30px;color:#a0a0a0;font-size:14px;"  v-if="row.is_freeze==1" v-text="icons.lock.icon" /> -->
              <v-icon style="with:30px;color:#a0a0a0;font-size:14px;"  v-if="row.is_freeze==1" >{{ icons.lock.icon }}</v-icon>
              {{ row.garden_name }}
            </td>
            <td>
              {{ row.totals }}
            </td>
            <td>
              {{ row.large }} | {{ row.middle }} | {{ row.small }}
            </td>
            <td>
              {{ row.construction_unit }}
            </td>
            <td>
              {{ row.construct_unit }}
            </td>
            <td >
              {{ row.supervision_unit }}
            </td>
            <td>
              {{ row.design_unit }}
            </td>
            <td>
              {{ row.invest_fee }}
            </td>
           
            
            <td v-if="row.construction_time">
              {{ row.construction_time }} 
            </td><td v-else></td>
            <td v-if="row.completed_time">
              {{ row.completed_time }} 
            </td><td v-else></td>
            <td v-if="row.delivery_time">
              {{ row.delivery_time }}
            </td><td v-else></td>
           
            <td>
              <v-btn color="warning" icon @click="goContracts(row.id)">
                <v-icon left>{{ icons.property.icon }}</v-icon>
              </v-btn>
              <v-btn color="warning" icon @click="goDetails(row.id)">
                <v-icon left>{{ icons.list.icon }}</v-icon>
              </v-btn>
              <v-btn color="green" icon @click="get_build(row.id)">
                <v-icon left>{{ icons.edit.icon }}</v-icon>
              </v-btn>
             
              <v-btn color="red" icon @click="removeBuild(row.id)">
                <v-icon left>{{ icons.delete.icon }}</v-icon>
              </v-btn>
            
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-pagination
      v-model="listQuery.page"
      :circle="circle"
      :disabled="disabled"
      :length="total_pages"
      :next-icon="nextIcon"
      :prev-icon="prevIcon"
      :total-visible="totalVisible"
      :value="listQuery.page"
      @input="paginationChangeHandler"
      class="my-3"></v-pagination>
     <div style="text-align: right;width: 100%;margin-bottom: 20px;margin-top: -44px;max-width: 100%;color: gray;">共有{{ total_items }}条记录</div>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
    </v-snackbar>
    <v-dialog v-model="dialog" max-width="1200">
    
    <v-container class="px-3 my-container" style="background-color: rgba(90, 90, 90, 0.9);">

      <div class="px-7 pb-5" height="800px">
        <v-card-title class="my-10"><h1>编辑建设主体</h1></v-card-title>
        <v-row>
          <v-text-field
            v-model="build.garden_name"
            color="yellow darken-3"
            label="小区名称"
            required
            class="mx-6"
            style="width:120px"
          ></v-text-field>

          <v-text-field
            v-model="build.totals"
            color="yellow darken-3"
            label="总套数"
            required
            class="mx-6"
            style="width:80px"
          ></v-text-field>
          <v-text-field
            v-model="build.large"
            color="yellow darken-3"
            label="大户型套数"
            required
            class="mx-6"
            style="width:80px"
          ></v-text-field>
          <v-text-field
            v-model="build.middle"
            color="yellow darken-3"
            label="中户型套数"
            required
            class="mx-6"
            style="width:80px"
          ></v-text-field>
          <v-text-field
            v-model="build.small"
            color="yellow darken-3"
            label="小户型套数"
            required
            class="mx-6"
            style="width:80px"
          ></v-text-field>
        </v-row>
        <v-row>
          <v-text-field
            v-model="build.construction_unit"
            color="yellow darken-3"
            label="施工单位"
            required
            class="mx-6"
            style="width:160px"
          ></v-text-field>
          <v-text-field
            v-model="build.construct_unit"
            color="yellow darken-3"
            label="建设单位"
            required
            class="mx-6"
            style="width:160px"
          ></v-text-field>
          <v-text-field
            v-model="build.supervision_unit"
            color="yellow darken-3"
            label="监理单位"
            required
            class="mx-6"
            style="width:160px"
          ></v-text-field>
          <v-text-field
            v-model="build.design_unit"
            color="yellow darken-3"
            label="设计单位"
            required
            class="mx-6"
            style="width:160px"
          ></v-text-field>
          <v-text-field
            v-model="build.survey_unit"
            color="yellow darken-3"
            label="勘察单位"
            required
            class="mx-6"
            style="width:160px"
          ></v-text-field>
        </v-row>
        
        <v-row>
          <v-text-field
            v-model="build.invest_fee"
            color="yellow darken-3"
            label="项目总投资(万元)"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="build.land_fee"
            color="yellow darken-3"
            label="其中土地成本(亿元)"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="build.construction_fee"
            color="yellow darken-3"
            label="建安成本（亿元）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="build.other_fee"
            color="yellow darken-3"
            label="其他费用（加成10%+9%税金）（亿元）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          </v-row>
        
        <v-row>
          <v-text-field
            v-model="build.loan_fee"
            color="yellow darken-3"
            label="银行贷款情况（贷款金额）（亿元）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="build.loan_rate"
            color="yellow darken-3"
            label="贷款利率（亿元）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="build.construction_interest"
            color="yellow darken-3"
            label="建设期利息（亿元）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="build.repayment"
            color="yellow darken-3"
            label="还款周期（年限及还本期）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
        </v-row>
        <v-row>
        <v-text-field
            v-model="build.total_area"
            color="yellow darken-3"
            label="总可销售面积（万平方米）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="build.sale_area"
            color="yellow darken-3"
            label="可销售面积（万平方米）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="build.sale_price"
            color="yellow darken-3"
            label="可售面积建设成本单价（万元每平米）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="build.taxes_fee"
            color="yellow darken-3"
            label="每平方加成、税金成本（万元每平米）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="build.tax_price"
            color="yellow darken-3"
            label="含代建费+税费的单价（万元每平米）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
        </v-row>
      <v-row>
        <v-text-field
            v-model="build.dpt_fee"
            color="yellow darken-3"
            label="预计大平台缴纳（亿元）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="build.nfjj_fee"
            color="yellow darken-3"
            label="预计农房集聚缴纳（亿元）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="build.empty_fee"
            color="yellow darken-3"
            label="空置房缴纳（按加成亿元）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="build.empty_diff"
            color="yellow darken-3"
            label="空置房差价"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="build.diff_fee"
            color="yellow darken-3"
            label="差额部分（亿元）"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
        </v-row>
        <v-row>
          <v-text-field
            v-model="build.construction_time"
            color="yellow darken-3"
            label="施工时间"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
         
          <v-text-field
            v-model="build.completed_time"
            color="yellow darken-3"
            label="竣工时间"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          
          
          <v-text-field
            v-model="build.expected_time"
            color="yellow darken-3"
            label="拟交付时间"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-menu
            v-model="delivery_menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="build.delivery_time"
                label="交房时间"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="build.delivery_time"
              @input="delivery_menu = false"
            ></v-date-picker>
          </v-menu>
          
        </v-row>
        <v-row>
          <v-text-field
            v-model="build.total_property"
            color="yellow darken-3"
            label="总物业费"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>
          <v-text-field
            v-model="build.government_property"
            color="yellow darken-3"
            label="政府承担"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>

          <v-text-field
            v-model="build.household_property"
            color="yellow darken-3"
            label="农户承担"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>

         
        </v-row>
        <v-row>
          <v-text-field
            v-model="build.remark"
            color="yellow darken-3"
            label="备注"
            required
            class="mx-6"
            style="width:60px"
          ></v-text-field>

        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <span class="mt-6 mx-3 orange--text" style="font-size:14px">
            本系统由 九色鹿网络 提供技术支持。
          </span>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="cancelEditDialog">取消</v-btn>
          <v-btn color="primary" @click="confirmEditDialog">确认</v-btn>
        </v-card-actions>
      </div>
    </v-container>
  </v-dialog>
  </v-container>
</template>

<script>
import {
  fetchBuilds,
  updateBuild,
  fetchBuild,
  deleteBuild,
} from "@/api/builds";


export default {
  name: "Customers",
  components: {
    AddBuildDialog: () => import("./addBuildDialog"),
    // EditBuildDialog: () => import("./editBuildDialog"),
  },
  data: () => ({
    printObj: {
      id: "printMe",
      popTitle: "good print",
      extraCss: "https://www.baidu.com",
      extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
    },
    dialog: false,
    Interest:false,
    snackbar: false,
    text: "",
    timeout: 3000,
    construction_menu:"",
    completed_menu:"",
    delivery_menu:"",
    icons: {
      property: {
        color: "blue",
        icon: "mdi-home-group"
      },
      edit: {
        color: "blue",
        icon: "mdi-file-edit"
      },
    
      list: {
        color: "",
        icon: "mdi-format-list-bulleted"
      },
      delete: {
        color: "green",
        icon: "mdi-delete"
      },
    
    },
    start_menu: "",
    end_menu: "",

    alert: false,
    alert_text: "",
    
    items: [],
    build: {},
    listQuery: {
      page: 1,
      limit: 12,
      garden_name: undefined,
    },
    search: "",
    awaitingSearch: false,
    circle: true,
    disabled: false,
    length: 10,
    nextIcon: "mdi-chevron-right",
    prevIcon: "mdi-chevron-left",
    totalVisible: 10,
    total_pages: 0,
    total_items:0,

  }),

  computed: {
    isAdminRole() {
      if (this.$store.getters.roles.includes("administrator")) {
        return true;
      } else {
        return false;
      }
    }
  },

  created() {
    this.getList();
  },
  mounted: {
   
  },
  methods: {
   
    getQuery() {
      this.listQuery.page = 1;
      this.getList();
    },
    changed() {},
    getList() {
      this.listLoading = true;
      this.listQuery.limit = 12;
      console.log(this.listQuery);
      fetchBuilds(this.listQuery).then(response => {
        this.items = response.data.items;
        this.total_pages = response.data._meta.total_pages;
        this.total_items = response.data._meta.total_items;
        console.log(this.items);

        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
    },

   
    getListforExport() {
      this.listLoading = true;
      this.listQuery.page = 1;
      this.listQuery.limit = 500;
      fetchBuilds(this.listQuery).then(response => {
        this.exportItems = response.data.items;
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
      return this.exportItems;
    },
    
    cancelDialog() {
      this.dialog = false;
    },
    cancelEditDialog() {
      this.dialog = false;
      this.build = {};
    },
   
    get_build(build_id) {
      this.dialog = true;
      fetchBuild(build_id).then(response => {
        this.build = response.data;
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
    },
    confirmEditDialog() {
      const tempData = this.build;
      console.log(tempData);
      updateBuild(this.build.id,tempData).then(() => {
        this.dialog = false;
        this.build = {};
        this.getList()
      });
    },
    resetQuery() {
      this.listQuery.garden_name = undefined;
      this.getList();
      console.log("resetQuery");
    },
    
    removeBuild(id) {
      this.$confirm("确认删除当前资料?").then(res => {
        if (res) {
          deleteBuild(id).then(response => {
            // console.log('response: ', response)
            if (response.data.error) {
              this.alert_text = response.data.error;
              this.alert = true;
            } else {
              this.getList();
              // Just to simulate the time of the request
              this.text = "当前资料删除成功！";
              this.snackbar = true;
            }
          });
        }
      });
    },
    goDetails(id) {
      // console.log(row.id)
      this.$router.push({
        name: "建设主体详情",
        params: { id: id }
      });
    },
    goContracts(id){
      this.$router.push({
        name: "物业费详情",
        params: { id: id }
      });
    },
    paginationChangeHandler(pageNumber) {
      console.log("paginationChangeHandler, pageNumber: ", pageNumber);
      this.listQuery.page = pageNumber;
      this.getList();
    },

    reset() {
      this.$refs.form.reset();
    },

    resetValidation() {
      this.$refs.form.resetValidation();
    },

  }
};
</script>

<style lang="scss" scoped>
$colors: (
  0 #03444d,
  1 #80594a,
  2 #4e3152,
  3 #856936,
  4 #255834,
  5 #2e3761,
  6 #6d2b36,
  7 #2b6d6a,
  8 #413370,
  9 #754719
);

$color: nth($colors, random(length($colors)));

@each $i in $colors {
  .bill_background-#{nth($i,1)} {
    background-color: nth($i, 2) !important;
    color: rgb(241, 233, 233) !important;
    font-weight: 500 !important;
    border-radius: 1px;
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 2px;
    padding-bottom: 2px;
    width: 92px;
  }
}

tr:hover {
  background-color: #0282b4 !important;
  color: rgb(224, 221, 221);
}

table,
thead,
tr {
  // color: rgb(160, 160, 160);
  font-weight: 400;
}
th,
td {
  text-align: center !important;
  vertical-align: middle;
  padding: 0 2px 0 2px !important;
}
.dialog-style {
  background-color: rgb(40, 40, 40) !important;
}

.tooltip {
  font-size: 16px;
}

.only-print {
  display: none;
}

@page {
  /* size: A4; */
  size: landscape;
  margin: 1px 1px;
}

@media print {
  .A4 {
    background: white;
    /* width: 21cm;
  height: 29.7cm; */
    width: 1122px;
    height: 794px;
    display: block;
    margin: auto;
    padding: auto;
    margin-bottom: 0cm;
    box-shadow: 0 0 0.5cm 0.5cm rgba(90, 88, 88, 0.1);
    overflow-y: auto;
    box-sizing: border-box;
  }

  .dialog-style {
    background-color: rgb(255, 254, 254) !important;
  }

  .no-print {
    display: none;
  }

  .only-print {
    display: block;
    font-weight: 400;
    font-size: 12px !important;
  }

  table,
  th,
  td {
    color: black !important;
    font-weight: 800;
    border: 1px solid !important;
    border-collapse: separate !important;
    // border-spacing: 5 !important;
  }
}
</style>
